export default __webpack_public_path__ + "static/Fellix-Bold-cfa1f85b8fca5465b2d53d2769ffa3de.woff2";